export const FilterName = {
    RESOURCES: 'resources',
    PARTNERS: 'partners',
    GLOBAL_MAP: 'data centers',
    REGION_MAP: 'region',
    METRO_MAP: 'metro',
    ARTICLES: 'blog',
    PRESS_RELEASES: 'press releases',
    PRODUCT_FAMILY: 'certifications compliance',
};